// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__MVMF4","label":"CategoryService_label__rvmbb","location":"CategoryService_location__etm2m"};